"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../schema");
const value = schema_1.Schema.number()
    .expiration(31536000)
    .unit("pmol/L")
    .min(0.01)
    .max(100)
    .interpretation({ vocab: "ktx", code: "lab_T4" })
    .tag({ vocab: "loinc", code: "14920-3", source: "synonym" })
    .tag({ vocab: "snomed", code: "166329005", source: "synonym" })
    .tag({ vocab: "ktx", code: "lab_procedure" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value });
